import React from 'react';
import styled from 'styled-components';
import DocsPageContentAnchor from './DocsPageContentAnchor';
import Anchor from '../../../components/Anchor';
import { IndentWidthType } from '../../../types';
import { DocsPageAnchorType } from '../types/DocsPageAnchorType';
import DocsPageContentCode from './DocsPageContentCode';
const DocsPageContent = ({ text = '', withIndent = IndentWidthType.NONE, className, children }) => {
    // TODO: refactor in Commons-UI or Docs-Commons
    //
    // transform any special text characters
    const transformedText = (text) => text && text.split(' ').map((word, index) => {
        // transform code snippets
        if (word.match(/`\S*`/g)) // captures all non-whitespace characters
         {
            word = word.replace(/`/g, '');
            word = word.split('/SPACE/').join(' ');
            return React.createElement(DocsPageContentCode, { key: index, children: word, fontSize: 15 });
        }
        // transform links
        else if (word.match(/\[(.*?)]/g)) // captures all text within [] brackets
         {
            const link = word.substring(word.indexOf('(') + 1, word.indexOf(')'));
            word = word.substring(word.indexOf('[') + 1, word.indexOf(']'));
            word = word.split('/SPACE/').join(' ');
            return React.createElement(DocsPageContentLink, { key: index, text: word, href: link, target: '_blank', rel: 'noopener noreferrer' });
        }
        else if (word.match(/\{(.*?)}/g)) // captures all text within {} brackets
         {
            const link = word.substring(word.indexOf('(') + 1, word.indexOf(')'));
            word = word.substring(word.indexOf('{') + 1, word.indexOf('}'));
            word = word.split('/SPACE/').join(' ');
            return React.createElement(DocsPageContentAnchor, { text: word, to: link, newWindow: false, size: DocsPageAnchorType.REGULAR });
        }
        // transform list items
        else if (word.match(/^((•)|(\d+\.)$)/)) {
            return React.createElement(DocsPageContentListItem, { key: index, text: word });
        }
        // transform rest
        else {
            return word + ' '; // add a buffer space for spacing in between words
        }
    });
    const hanledNewLineTexts = text && text.split('{NEWLINE}').map((example, index) => {
        return (example.trim().length > 0 ? React.createElement(NewLineTextWrapper, { key: index }, transformedText(example)) : React.createElement(NewLine, null));
    });
    return React.createElement(DocsPageContentWrapper, { withIndent: withIndent, className: className },
        hanledNewLineTexts,
        children);
};
export default DocsPageContent;
const DocsPageContentWrapper = styled.span `
  display: block;
  
  margin: ${props => props.withIndent === IndentWidthType.NONE && '20px 0px'};

  padding-left: 0px;
  padding-left: ${props => props.withIndent === IndentWidthType.NONE && '0px'};
  padding-left: ${props => props.withIndent === IndentWidthType.SMALL && '50px'};
  padding-left: ${props => props.withIndent === IndentWidthType.MEDIUM && '100px'};
  padding-left: ${props => props.withIndent === IndentWidthType.LARGE && '150px'};
  padding-left: ${props => props.withIndent === IndentWidthType.XLARGE && '200px'};

  font-family: ${props => props.theme.fonts.regular};

  font-size: 16px;
  line-height: 20px;

  color: ${props => props.theme.colors.blackLight};
`;
const DocsPageContentListItem = styled.span `
  ::before {
    content: "${props => props.text}";
    margin-right: 15px;
  }
`;
const DocsPageContentLink = styled(Anchor) `
  display: inline !important;

  margin-right: 3px !important;

  font-size: 16px;
`;
const NewLineTextWrapper = styled.div `
  display: block;
`;
const NewLine = styled.div `
  display: block;
  margin-bottom: 10px;
`;
//# sourceMappingURL=DocsPageContent.js.map